import { AtividadeToList } from './types';
import { Atividade } from '../../@types';
import getSaveErrorMessage from '../../utils/error-message';

const tipoParse = {
  agricola: 'Agrícola',
  leiteira: 'Leiteira',
  corte_pecuaria: 'Pecuária de Corte',
  permanente: 'Permanente',
} as const;

const messages = {
  abreviatura: {
    'já está em uso': 'Essa abreviatura já está em uso.',
    'é muito longo (máximo: 3 caracteres)':
      'Abreviatura é muito longa (máximo 3 caracteres).',
    default: 'Abreviatura inválida.',
  },
  descricao: {
    'já está em uso': 'Essa descrição já está em uso.',
    default: 'Descrição inválida.',
  },
};

export const getMessagesAtividades = (
  error: unknown,
  status: 'create' | 'edit',
): string => getSaveErrorMessage(error, status, messages);

export const convertAtividadesToList = (data: Atividade[]) =>
  data.map<AtividadeToList>((atividade) => ({
    ...atividade,
    humanizedTipo: tipoParse[atividade.tipo],
  }));
